import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import { Settings } from '@material-ui/icons';
import {
  AppBar,
  Badge,
  IconButton,
  Tooltip,
  Toolbar,
} from '@material-ui/core';

import { useAppContext } from 'Scenes/_root/appContext';
import {
  MeetingContextDeviceControlsProps,
  withMeetingContext,
} from 'Scenes/_root/meetingContext';
import NoDeviceSetWarnings from './NoDeviceSetWarnings';
import Logout from './Logout';
import styles from './styles.scss';

const DeviceSettingsBar = ({
  deviceControls,
  registerMeetingCallbacks,
  openDeviceSettingsModal,
}) => {
  const { isLoggedIn } = useAppContext();
  const [hasWarning, setHasWarning] = useState(false);
  const checkIfShowWarning = () => {
    const { audioIn, video } = deviceControls.getSelectedDeviceIds();
    if (!audioIn || !video) {
      setHasWarning(true);
    } else {
      setHasWarning(false);
    }
  };

  useEffect(() => {
    checkIfShowWarning();
    return registerMeetingCallbacks('deviceSettingsBar', {
      onSelectedAudioInDeviceIdUpdated: checkIfShowWarning,
      onSelectedVideoDeviceIdUpdated: checkIfShowWarning,
    });
  }, []);
  return (
    <React.Fragment>
      <AppBar
        classes={{ root: styles.deviceSettingBar }}
      >
        <Toolbar>
          <NoDeviceSetWarnings />
          <div className={styles.grow} />
          <Tooltip placement='top' title='Settings'>
            <IconButton
              edge={!isLoggedIn && 'end'}
              onClick={openDeviceSettingsModal}
            >
              <Badge
                color='error'
                invisible={!hasWarning}
                variant='dot'
              >
                <Settings />
              </Badge>
            </IconButton>
          </Tooltip>
          {isLoggedIn && <Logout />}
        </Toolbar>
      </AppBar>
      <div className={styles.offset} />
    </React.Fragment>
  );
};

const MapDispatchProps = {
  openDeviceSettingsModal: func.isRequired,
};

DeviceSettingsBar.propTypes = {
  deviceControls: MeetingContextDeviceControlsProps,
  registerMeetingCallbacks: func.isRequired,
  ...MapDispatchProps,
};

export default withMeetingContext([
  'registerMeetingCallbacks',
  'deviceControls',
])(DeviceSettingsBar);
